import { createHOC } from 'vue-hoc';
import { findIndex } from 'lodash';

import withUser from '~lib/common/hoc/withUser';
import withUserPrefs from '~lib/common/hoc/withUserPrefs';
import dataView from '~lib/common/hoc/dataView';
import auth from '~lib/common/providers/auth';
import queries from '~lib/common/queries/CaseConfiguration';

import CaseList from './CaseList';

const options = {
  name: 'CaseListContainer',
  data() {
    return {
      state: {
        fetchingCaseId: null,
        previewedCase: null,
      },
    };
  },
  created() {
    if (this.caseLoadId) {
      this.loadAndSelect(this.caseLoadId);
    }
    auth.on('permissionsChanged', () => {
      window.location.reload();
    });
  },
  computed: {
    caseLoadId() {
      if (!this.store) {
        return;
      }
      return this.$store.getters['caseSelect/caseLoadId'];
    },
  },
  watch: {
    caseLoadId(newValue, oldValue) {
      if (oldValue !== newValue && newValue) {
        this.loadAndSelect(newValue);
      }
    },
    data(newValue, oldValue) {
      if (oldValue !== newValue && newValue && this.state.fetchingCaseId) {
        // Case fetched by fetchOne is now avaiable
        this.select(this.state.fetchingCaseId);
      }
    }
  },
  methods: {
    loadAndSelect(caseId) {
      const index = findIndex(this.data, { id: caseId });
      if (index === -1) {
        this.state.fetchingCaseId = caseId;
        this.$emit('fetchOne', caseId);
      } else {
        this.select(caseId);
      }
    },
    select(caseId) {
      if (!this.$store) {
        return;
      }
      this.$store.commit('caseSelect/caseLoadId', undefined);
      let index = findIndex(this.data, { id: caseId });
      if (index >= 0) {
        this.state.previewedCase = this.data[index];
        this.$emit('previewCase', this.data[index]);
      }
    }
  }
};

const renderWith = {
  props: {
    previewedCase() {
      return this.state.previewedCase;
    },
  },
  listeners: {
    previewCase(caseConf) {
      this.state.previewedCase = caseConf;
      this.$emit('previewCase', caseConf);
    },
    loadAndSelect(caseId) {
      this.loadAndSelect(caseId)
    }
  },
};

const CaseListContainer = createHOC(CaseList, options, renderWith);
const ContainerWithUser = withUser()(withUserPrefs()(CaseListContainer));
export default dataView({ queries, append: true, sortBy: '-needsEcUpdate,-lastAccessed' })(ContainerWithUser);
